import {
	CHANGE_ACTIVE_TAB,
	FAILED_TO_RECEIVE_APPLICATION_IPT,
	GET_APPLICATION_IPT, LOGOUT, RECEIVE_APPLICATION_IPT,	
	RECEIVE_BAD_REQUEST_APPLICATION_PREMIUM_SETTINGS,
	RECEIVE_BAD_REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP, RECEIVE_FAILED_RESPONSE_GET_SOLICITOR_DETAILS,	
	RECEIVE_GET_SOLICITOR_DETAILS,
	RECEIVE_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP, REQUEST_GET_SOLICITOR_DETAILS,
	REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP
} from "../actions/index";


const defaultState = {
	underwriter: {},
	fetchingIpt: false,
	fetchingSchedules: false,
	fetchingUnderwriter: false,
	fetchingSolicitorDetails: false,
	fetchingScheduleFooter: false,
	ipt: [],
	schedules: [],
	haveDataRequired: true,
	scheduleFooter: []
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case CHANGE_ACTIVE_TAB:
			return {
				...defaultState,
				underwriter: state.underwriter,
				ipt: state.ipt,
				schedules: state.schedules
			};
		case REQUEST_GET_SOLICITOR_DETAILS:
			return {
				...state,
				fetchingSolicitorDetails: true
			};
		case RECEIVE_GET_SOLICITOR_DETAILS:
			return {
				...state,
				fetchingSolicitorDetails: false
			};
		case RECEIVE_FAILED_RESPONSE_GET_SOLICITOR_DETAILS:
			return {
				...state,
				fetchingSolicitorDetails: false,
				haveDataRequired: false
			};		
		case GET_APPLICATION_IPT:
			return {
				...state,
				fetchingIpt:true
			};
		case RECEIVE_APPLICATION_IPT:
			return {
				...state,
				fetchingIpt: false,
				ipt: action.payload
			};
		case FAILED_TO_RECEIVE_APPLICATION_IPT:
			return {
				...state,
				fetchingIpt: false,
				haveDataRequired: false
			};
		case RECEIVE_BAD_REQUEST_APPLICATION_PREMIUM_SETTINGS:
			return {
				...state,
				haveDataRequired: false
			};
		case REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP:
			return {
				...state,
				fetchingUnderwriter: true
			};
		case RECEIVE_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP:
			return {
				...state,
				underwriter: action.payload,
				fetchingUnderwriter: false
			};
		case RECEIVE_BAD_REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP:
			return {
				...state,
				fetchingUnderwriter: false,
				haveDataRequired: false
			};		
		case LOGOUT:
			return {
				...defaultState
			};
		default :
			return state
	}
}